/**
 * Redact's aiWARE application config definitions — the canonical list.
 *
 * FOUR LISTS, AND WHICH ONE A KEY IS IN IS A CLAIM ABOUT THAT KEY:
 *
 *   standard    expected in every environment                    absence is a finding
 *   advanced    expected too; just not what people come for      absence is a finding
 *   developer   NOT expected; registered only on purpose         absence is fine
 *   deprecated  retired; it should not exist anywhere            presence is a finding
 *
 * THE LINE IS WHETHER THE KEY SHOULD BE REGISTERED EVERYWHERE. `standard` and
 * `advanced` both should, and differ only in prominence — advanced gets its own
 * tab so the default view stays the keys people come here for. A `developer`
 * key should not: it is a knob an environment may be given deliberately, and
 * one without it is working as intended, so the page says "Not registered"
 * rather than "Missing" and offers no bulk register on that tab.
 *
 * All three are still DIFFED identically when present — a registered developer
 * key with the wrong type or default is as drifted as any other. The tier
 * changes what an ABSENCE means, not what a difference means.
 *
 * (`developer` has therefore arrived at the job the deleted `optional` list was
 * created for. It does it better: these are full definitions, so a key here can
 * be registered from the page and is checked properly once it is, where an
 * optional entry was a note and nothing more.)
 *
 * There was a fifth, `optional` — "an environment MAY set this, never reported
 * missing". It was added when a key read only through the `featureFlags` blob
 * turned up registered on a stage environment and landed in Unrecognized,
 * behind a Delete permanently button. It is gone because it was never the thing
 * that prevented that: the manifest-completeness test is, and it works without
 * a list to park keys in. A key we know about belongs in `standard` or
 * `developer`, where it stays honest. Re-add the list if a key ever genuinely
 * must not be required — but re-add it for that key, not for the idea.
 *
 * TypeScript rather than JSON, and the reason is in the files: the JSON version
 * carried a single three-thousand-character `$comment` because JSON has no
 * comments, bundling eight unrelated explanations — why `transcriptionEngineId`
 * declares no default, why the thumbnail timeouts are String and not Integer,
 * what `relockSleep` actually reads — nowhere near the entries they were about.
 * Here each one sits on the entry it explains. The second reason is that
 * `resolveJsonModule` widens `"Boolean"` to `string`, so the old loader needed
 * `as unknown as ConfigDefinitionManifest` — a double cast that turned a typo'd
 * `configType` into a runtime finding instead of a compile error.
 *
 * `validateManifest` still runs over this at test time. Types cannot catch the
 * one failure splitting the file makes easier: the same configKey appearing in
 * two of the three lists.
 */
import { ConfigDefinitionManifest } from '@redact-modules/admin/models';
import { ADVANCED_DEFINITIONS } from './advanced';
import { DEPRECATED_ENTRIES } from './deprecated';
import { DEVELOPER_DEFINITIONS } from './developer';
import { STANDARD_DEFINITIONS } from './standard';

export const CONFIG_DEFINITION_MANIFEST: ConfigDefinitionManifest = {
  definitions: STANDARD_DEFINITIONS,
  advanced: ADVANCED_DEFINITIONS,
  developer: DEVELOPER_DEFINITIONS,
  deprecated: DEPRECATED_ENTRIES,
};

export {
  ADVANCED_DEFINITIONS,
  DEPRECATED_ENTRIES,
  DEVELOPER_DEFINITIONS,
  STANDARD_DEFINITIONS,
};
